export default function useGetSessionStorageItem<T>(key: string): T | null {
  const item = window.sessionStorage.getItem(key);
  if (item) {
    try {
      return JSON.parse(item) as T;
    } catch (e) {
      console.error("Failed to parse session storage item:", e);
    }
  }
  return null;
}
